<div>
  <section class="flex-row">

    <panel
      [heading]="'shared.support.generalSupportHeading' | translate"
      [subHeading]="'shared.support.generalSupportSubHeading' | translate"
      [icon]="{ isActive: true, iconType: 'fa-headset' }"
    >
      <div class="support-card">
        <p>{{ 'shared.support.supportMessage' | translate }}</p>
        <div class="email-wrapper">
          <i class="fa-solid fa-envelope"></i>
          <a href="mailto:{{supportEmailAddress}}">{{ supportEmailAddress }}</a>
        </div>
      </div>
    </panel>

    <panel
      [heading]="'shared.support.hoaHeading' | translate"
      [subHeading]="'shared.support.hoaSubHeading' | translate"
      [icon]="{ isActive: true, iconType: 'fa-headset' }"
      [seeAllIsActive]="false"
      *ngIf="loggedInUser?.role?.roleName?.toLowerCase().includes('analyst') && getHoA()"
    >
      <div class=" support-card">
        <p>{{ 'shared.support.hoaSupportMessage' | translate }}</p>
        <p>{{ fiuHoa?.firstName }} {{ fiuHoa?.lastName }}</p>
        <div class="email-wrapper">
          <i class="fa-solid fa-envelope"></i>
          <a href="mailto:{{ fiuHoa?.emailAddress }}">{{ fiuHoa?.emailAddress }}</a>
        </div>
      </div>
    </panel>
  </section>
</div>
